import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Hotspot from '../../reports/views/Hotspot';
import useApi from '../../hooks/useApi';
import useSnackbar from '../../hooks/useSnackbar';

const EditCampaignLinkHotspotDialog = ({ campaignID, onClose }) => {
    const { handleGet } = useApi();
    const { showSnackbar } = useSnackbar();
    const [html, setHtml] = useState(null);
    const [itemLinks, setItemLinks] = useState(null);

    const handleFetchLinks = async () => {
        const response = await handleGet(`superadmin/campaigns/${campaignID}/links`);

        if (!response.ok) {
            showSnackbar('Error fetching Links', 'error');
            return;
        }

        setItemLinks(await response.json());
    };

    const handleFetchHtml = async () => {
        const response = await handleGet(`superadmin/campaigns/${campaignID}/html`);

        if (!response.ok) {
            showSnackbar('Error fetching HTML', 'error');
            return;
        }

        setHtml(await response.text());
    };

    const handleFetch = () => {
        handleFetchHtml();
        handleFetchLinks();
    };

    useEffect(() => {
        handleFetch();
    }, [campaignID]);

    return (
        <Dialog maxWidth="md" onClose={onClose} open={true}>
            <form style={{ height: '100%' }}>
                <DialogTitle>Edit Links</DialogTitle>
                <DialogContent dividers>
                    {(html && itemLinks) && (
                        <Hotspot
                            html={html}
                            itemLinks={itemLinks}
                            campaignID={campaignID}
                            onRefetch={handleFetch}
                            editLink={true}
                        />
                    )}
                </DialogContent>
            </form>
        </Dialog>
    );
};

export default EditCampaignLinkHotspotDialog;